import { Select } from "@mantine/core";
import { SelectOption } from "grapesjs";

export const SelectPropertyField = (props: {
  value: string;
  defaultValue: string;
  options: SelectOption[];
  onChange: (value: string | null) => void;
}) => {
  const { value, defaultValue, options, onChange } = props;

  return (
    <Select
      size="xs"
      value={value}
      placeholder={defaultValue}
      onChange={onChange}
      data={options.map((option) => ({
        value: option.id,
        label: option.label || option.id,
      }))}
      styles={{
        input: {
          padding: "0 8px",
          height: "40px",
          margin: 0,
        },
      }}
    />
  );
};
